import { Block, CircleLoader, Typography, spacing } from "@stepapp/ui";
import { useTranslation } from "react-i18next";
import { StyleSheet } from "react-native";
import Animated, { FadeIn } from "react-native-reanimated";

const EditReservationLoading = () => {
  const { t } = useTranslation();

  return (
    <Animated.View entering={FadeIn} style={styles.container}>
      <Block paddingBottom={10}>
        <Typography center variant="title">
          {t("screens.serviceDetails.submitChangeLoader")}
        </Typography>
      </Block>

      <CircleLoader />
    </Animated.View>
  );
};

export default EditReservationLoading;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: spacing.unit * 2.5,
    paddingBottom: spacing.unit * 10,
    paddingTop: spacing.unit * 4,
    justifyContent: "center",
    alignItems: "center",
  },
});
